import { render, staticRenderFns } from "./g-empty.vue?vue&type=template&id=60bd407a&scoped=true"
var script = {}
import style0 from "./g-empty.vue?vue&type=style&index=0&id=60bd407a&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60bd407a",
  null
  
)

export default component.exports